// import _get from "lodash";
const FeedbackParser = {};
FeedbackParser.getFeedbackParser = (res) => {
  if (!res) {
    return {};
  }

const data = res.result;
 
  if (res) {
    res = data;
    return res;
  }
};  



export { FeedbackParser };